import {
    GET_FESTIVAL_DETAILS_SUCCEEDED, 
    GET_FESTIVALS_SUCCEEDED, 
    GET_FESTIVAL_LOCATIONS_SUCCEEDED, 
    GET_EVENTS_SUCCEEDED, 
    GET_EVENT_DETAILS_SUCCEEDED
} from '../actions/types';

const initialState = {
    festivalDetails: {},
    festivals: [],
    festivalLocations: [],
    events: [],
    eventDetails: {}
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_FESTIVAL_DETAILS_SUCCEEDED:
            return {
                ...state,
                festivalDetails: action.payload
            };
        case GET_FESTIVALS_SUCCEEDED:
            return {
                ...state,
                festivals: action.payload
            }
        case GET_FESTIVAL_LOCATIONS_SUCCEEDED:
            return {
                ...state,
                festivalLocations: action.payload
            }
        case GET_EVENTS_SUCCEEDED:
            return {
                ...state,
                events: action.payload
            }
        case GET_EVENT_DETAILS_SUCCEEDED:
            return {
                ...state,
                eventDetails: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/festival.reducer.js